module.exports = __webpack_public_path__ + "static/media/achieve1.36de38b3.png";